import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AboutComponent } from 'app/components/about/about.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AboutService {

  constructor(private dialog: MatDialog) { }

  openDialog(data: any): Observable<boolean> {
    const dialogRef = this.dialog.open(AboutComponent, {
      data: data,
    });

    return dialogRef.afterClosed();
  }
}
